import React from 'react';
import { Button, ModalContent} from "@deere/fuel-react";
import FindOtherSupplierSelect from "../FindOtherSupplierSelect";

export const SupplierModalContent = ({onContentChange}) => {
    return (
        <ModalContent>
            <FindOtherSupplierSelect onContentChange={onContentChange}/>
        </ModalContent>
    );
};

export const SupplierModalButton = ({handleClickOpen}) => {
    return (
        <Button variant="secondary" onClick={handleClickOpen}>Find Different Supplier</Button>
    );
};



